import FormEvidence from "./components/FormEvidence";
import { useSpeedLimitCertificateCommand } from "./hooks/useSpeedLimitCertificateCommand.js";

function RegisterSpeedLimitCertificate() {
    const {
    speedLimitCertificate,
    createSpeedLimitCertificate,
    errors: { errors },
    handleChange,
    loading,
  } = useSpeedLimitCertificateCommand();

  const handleSubmit = (event) => {
    event.preventDefault();
    createSpeedLimitCertificate(speedLimitCertificate);
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Registrar certificado de limite de velocidad</h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro certificados de limite de velocidad. Asegúrate de completar
              todos los campos requeridos.
            </p>
            <FormEvidence
              data={speedLimitCertificate}
              onChange={handleChange}
              onSubmit={handleSubmit}
              errors={errors}
              loading={loading}
              typeFiles=".pdf"
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterSpeedLimitCertificate;